import * as Sentry from '@sentry/react';
import type { ReactNode } from 'react';
import { ErrorFallback } from '@/components/shared/placeholders/Error';

interface DashboardErrorBoundaryProps {
  children: ReactNode;
}

export function DashboardErrorBoundary({
  children,
}: DashboardErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <ErrorFallback label="Something went wrong in the Dashboard tab" />
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
